var Vendd = (function (Vendd) {
    'use strict';

    Vendd.MessageBus.subscribe(Vendd.TrackTrace.Messages.GetTrackTraceModel, Vendd.TrackTrace, function (envelope) {
        
        var options = {
            url: 'TrackTraceService.svc/GetTrackTraceViewModel',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.TrackTrace, new Vendd.TrackTrace.Messages.GetTrackTraceModelSuccess(response));

        };
            
        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.TrackTrace, new Vendd.TrackTrace.Messages.GetTrackTraceModelFailure(response));
        };

        Vendd.Service.call(options);

        return;

    });

    return Vendd;

})(Vendd || {});